import {
    AfterViewInit,
    Component,
    ElementRef, EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit, Output,
    QueryList,
    SimpleChanges,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {Router} from '@angular/router';
import {WebsocketService} from '../websocket.service';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ListenerService} from '../listener.service';
import {Location} from '@angular/common';
import {interval} from 'rxjs';

@Component({
    selector: 'app-progress-logs',
    templateUrl: './progress-logs.component.html',
    styleUrls: ['./progress-logs.component.scss']
})
export class ProgressLogsComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild('scrollframe1', {static: false}) scrollFrame: ElementRef;
    @ViewChildren('item') itemElements: QueryList<any>;

    itemContainer: any;
    items = [];
    isNearBottom = true;

    @Input() progressing = false;
    selectedCredentialTabIndex = 0;
    logs = {};
    logsKey = [];
    logVisible: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    selectedIndex = -1;
    @Input() action = 'deploy';
    apiName: any;
    apiVersion: any;
    @Input() entityName: string;
    @Input() version: string;
    @Input() currentMessage: any;
    @Input() apiType: any;
    @Input() connection = true;
    @Input() session = localStorage.getItem('sessionID');
    @Input() logTimeStamp: any;
    @Input() refreshCount: number;
    @Input() queryOnInit = true;
    @Input() topic: string;
    showLogsWithQuery = false;
    actionName = '';
    operations: any;
    scrollContainer: any;
    errorsLogs = [];
    @Input() timeStamp = '';
    previousMessages: any;
    selected: any;
    messagesLoading = false;
    currentTopic = '';

    showNavigation = true;

    // pubSubSubscription: Subscription;

    @Output() CloseClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() apiActionLog: EventEmitter<any> = new EventEmitter<any>();

    constructor(private router: Router, private webSocket: WebsocketService, private confPost: ConfService, private _service: ConnecttocrudService,
                private platform: LeftpanelComponent, private location: Location, private leftPanelDataListener: ListenerService) {

        // if (this.action === 'redeploy') {
        //     this.actionName = 'Redeployment';
        // } else {
        //     this.actionName = 'Deployment';
        // }

    }


    async ngOnInit() {

        if (this.webSocket.isOpen()) {
            this.connection = true;
        } else {
            this.connection = false;
        }

        if (this.refreshCount > 0) {
            this.showLogsWithQuery = true;
        }
        const action = this.action;
        if (action !== 'deploy' && action !== 'redeploy') {
            this.showNavigation = false;
        }

        this.actionName = this.action === 'redeploy' ? 'Redeployment' : this.action === 'promote' ? 'Promotion' : this.action === 'Copy' ? 'Copy' : 'Deployment';
        if (this.queryOnInit) {
            this.messagesLoading = true;
            await this.getPubSubMessages(this.topic);
            if (this.webSocket.isOpen()) {
                this.webSocket.listenAPICreation(this.partner, this.account, this.entityName, this.version, this.session, this.timeStamp, action).subscribe(data => {
                    if (data) {
                        const currentMsg = JSON.parse(data.body);
                        this.messagesLoading = false;
                        this.onMessageReceived(currentMsg, false);
                    }
                });
            }
        }


    }

    editAPI() {
        switch (this.apiType) {
            case 'DATAACCESS':
                this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
                this.closeLogPanel();
                break;
            case 'BUSINESSLOGIC':
                this.router.navigateByUrl('/businesslogic/edit?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
                this.closeLogPanel();
                break;
            case 'SQLQUERY':
                this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
                this.closeLogPanel();
                break;
            case 'TESTSUITE':
                this.router.navigateByUrl('/testsuite?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
                this.closeLogPanel();
                break;
            case 'WORKFLOW':
                this.router.navigateByUrl('/workflow?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
                this.closeLogPanel();
                break;
        }
    }

    async createAPI() {
        switch (this.apiType) {
            case 'DATAACCESS':
                await this.router.navigateByUrl('/dataaccessapi');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                break;
            case 'BUSINESSLOGIC':
                await this.router.navigateByUrl('/businesslogic');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                break;
            case 'SQLQUERY':
                await this.router.navigateByUrl('/querybuilder');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                break;
            case 'TESTSUITE':
                await this.router.navigateByUrl('/testsuite');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                break;
            case 'WORKFLOW':
                await this.router.navigateByUrl('/workflow');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                break;
        }
    }

    manageData() {
        this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
    }

    APIDocumentation() {
        if (this.apiType === 'DATAACCESS') {
            this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version + '&showDoc=true');
        } else {
            this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&executor_name=' + this.entityName + '&executor_version=' + this.version + '&showDoc=true');
        }
    }

    executeCreatedAPI() {
        if (this.apiType === 'DATAACCESS') {
            this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.entityName + '&version=' + this.version);
        } else {
            this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&executor_name=' + this.entityName + '&executor_version=' + this.version);
        }
    }

    getPubSubMessages(topic) {
        return new Promise((resolve, reject) => {

            const timeStamp = this.timeStamp ? this.timeStamp.toString() : '';

            // const pubSubMessageQuery = '/' + this.partner + '.' + this.account + '.' + this.entityName + '.' + this.version + '.' + this.session + '.' + this.timeStamp.toString() + '.' + this.action + '.message';
            let queueName = this.partner + '.' + this.account + '.' + this.entityName + '.' + this.version + '.' + this.session + '.' + timeStamp + '.' + this.action;
            if (topic) {
                queueName = topic;
            }
            this.confPost.getPubSubMessages(queueName).subscribe(data => {
                this.logs = {};
                this.logsKey = [];
                this.errorsLogs = [];
                this.selectedIndex = -1;
                this.operations = [];
                this.previousMessages = data;
                if (this.previousMessages && this.previousMessages.length) {
                    for (const message of this.previousMessages) {
                        this.onMessageReceived(message.message, true);
                    }
                }
                this.messagesLoading = false;
                resolve('success');
            }, error => {
                this.messagesLoading = false;
                resolve('failure');
            });
        });
    }

    async ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                switch (propName) {
                    case 'currentMessage':
                        if (this.currentMessage) {
                            this.onMessageReceived(this.currentMessage, false);
                        }
                        break;
                    case 'timeStamp':
                        this.logs = {};
                        this.logsKey = [];
                        this.errorsLogs = [];
                        this.selectedIndex = -1;
                        this.operations = [];
                        break;
                    case 'refreshCount':
                        if (this.refreshCount > 0) {
                            this.showLogsWithQuery = true;

                            this.messagesLoading = true;
                            let count = 0;
                            const pubSubSubscription = interval(5000).subscribe((async x => {
                                await this.getPubSubMessages(this.topic);
                                if (this.logsKey.filter(function (e) {
                                        return e.name === 'DONE';
                                    }).length > 0 ||
                                    this.errorsLogs.filter(function (e) {
                                        return e.type === 'Fatal';
                                    }).length > 0 || count > 4) {
                                    pubSubSubscription.unsubscribe();
                                }
                                count++;

                                // this.errorsLogs.filter(function(e) { return e.type === 'fatal'; }).length > 0
                            }));

                        } else {
                            this.showLogsWithQuery = false;
                        }
                }

            }
        }
    }

    // checkForFatalLogs(): boolean {
    //
    // }

    getColor(status) {
        switch (status) {
            case 'initial':
                return 'black';
            case 'success':
                return 'green';
            case 'failed':
                return 'red';
        }
    }

    onMessageReceived(response, queryData) {
        this.apiName = response['apiName'];
        this.apiVersion = response['apiVersion'];
        this.action = response['action'];

        let temp: any;
        let index: number;

        if (response.hasOwnProperty('title')) {
            temp = response['title'].split(' ');
            temp = temp.join('_');
        }

        if (!(this.logs.hasOwnProperty(response['title']))) {
            // this.selectedIndex++;
            this.logsKey.push({
                name: response['title'],
                icon: response['message']['icon'],
                classname: temp
            });
            if (response['title'] !== 'DONE') {
                this.logs[response['title']] = [];
                // const status = response['message']['type'] === 'initial' || response['message']['type'] === 'retry' ? 'initial' :
                //     response['message']['type'] === 'success' ? 'success' : 'failed';
                // const obj = {
                //     status: status,
                //     info: response['message']['info']
                // };
                // this.logs[response['title']].push(obj);
            } else if (response['title'] === 'DONE') {
                this.getEntity();
            }
        }

        if (this.logs[response['title']]) {
            index = this.logs[response['title']].findIndex(value => value['info'] === response['message']['info']);
        } else {
            index = -1;
        }
        switch (response['message']['type']) {
            case 'error':
                let className = response['message']['info'].replace(/<[^>]*>/g, '').replace(/[^a-zA-Z ]/g, '').split(' ');
                className = className.join('_');
                const headerPayload = [{key: 'Content-Type', value: 'application/json', description: '', req: false}];
                if (response['message']['apikey']) {
                    headerPayload.push({key: 'apikey', value: response['message']['headers']['apikey'], description: '', req: false});
                }
                if (response['message']['pkey']) {
                    headerPayload.push({key: 'pkey', value: response['message']['headers']['pkey'], description: '', req: false});
                }
                const payload = {
                    'partner': response['partner'],
                    'account_id': response['account'],
                    'executor_name': '',
                    'executor_type': '',
                    'executor_version': '',
                    'executor_method_type': response['message']['executor_method_type'],
                    'apiUrl': response['message']['url'],
                    'dataroot': null,
                    'queryParams': response['message']['queryParameters'],
                    'pathParams': response['message']['pathParameters'],
                    'headers': headerPayload,
                    'requestBody': {
                        annotation: 'RequestBody',
                        description: 'Document in JSON format',
                        key: 'payload',
                        value: response['message']['request_body']
                    },
                    'prerequisites': null,
                    'authModel': {
                        'authAttributes': response['message']['authorization']
                    }
                };
                const errorPayload = {
                    info: response['message']['info'],
                    type: response['message']['type'],
                    title: response['title'],
                    partner: response['partner'],
                    account: response['account'],
                    executor_name: response['apiName'],
                    version: response['apiVersion'],
                    session: response['session'],
                    timeStamp: response['timeStamp'],
                    className: className,
                    action: response['action'],
                    executor_model: payload
                };
                errorPayload['description'] = response['message']['description'] ? response['message']['description'].toString() : '';
                this.errorsLogs.push(errorPayload);
                if (index !== -1) {
                    this.logs[response['title']][index]['status'] = 'failed';
                } else {
                    const obj = {
                        info: response['message']['info'],
                        status: 'failed'
                    };
                    this.logs[response['title']].push(obj);
                }
                break;
            case 'fatal':
                let description: any;
                if (response['message']['description'] && response['message']['description'] !== undefined) {
                    description = response['message']['description'];
                } else {
                    description = response['message']['info'];
                }
                const fatalPayload = {
                    title: response['title'],
                    className: response['message']['info'].replace(/<[^>]*>/g, '').replace(/[^a-zA-Z ]/g, '').split(' ').join('_'),
                    type: 'Fatal'
                };
                fatalPayload['description'] = response['message']['description'] ? response['message']['description'].toString() : '';
                this.errorsLogs.push(fatalPayload);
                if (index !== -1) {
                    this.logs[response['title']][index]['status'] = 'failed';
                } else {
                    const obj = {
                        info: response['message']['info'],
                        status: 'failed'
                    };
                    this.logs[response['title']].push(obj);
                }
                break;
            case 'retry':
                if (index !== -1) {
                    this.logs[response['title']][index]['status'] = 'initial';
                } else {
                    const obj = {
                        info: response['message']['info'],
                        status: 'initial'
                    };
                    this.logs[response['title']].push(obj);
                }
                break;
            case 'initial':
                if (!queryData) {
                    if (index === -1) {
                        const obj = {
                            info: response['message']['info'],
                            status: 'initial'
                        };
                        this.logs[response['title']].push(obj);
                    }
                }
                break;
            case 'success':
                if (index !== -1) {
                    if (this.logs[response['title']][index]['status'] === 'retry') {
                        const successIndex = this.errorsLogs.findIndex(value => value['info'] === response['message']['info']);
                        this.errorsLogs = this.errorsLogs.splice(successIndex, 1);
                    }
                    this.logs[response['title']][index]['status'] = 'success';
                    this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
                    this.logs[response['title']][index]['description'] = response['message']['description'];
                    this.logs[response['title']][index]['data'] = response['message']['data'];
                } else {
                    if (response['title'] !== 'DONE') {
                        const obj = {
                            info: response['message']['info'],
                            status: 'success',
                            messageType: response['message']['messageType'],
                            description: response['message']['description'],
                            data: response['message']['data'],
                        };
                        this.logs[response['title']].push(obj);
                    }
                }
                break;
            case 'warning':
                if (index !== -1) {
                    if (this.logs[response['title']][index]['status'] === 'retry') {
                        const successIndex = this.errorsLogs.findIndex(value => value['info'] === response['message']['info']);
                        this.errorsLogs = this.errorsLogs.splice(successIndex, 1);
                    }
                    this.logs[response['title']][index]['status'] = 'warning';
                    this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
                    this.logs[response['title']][index]['description'] = response['message']['description'];
                    this.logs[response['title']][index]['data'] = response['message']['data'];
                } else {
                    if (response['title'] !== 'DONE') {
                        const obj = {
                            info: response['message']['info'],
                            status: 'warning',
                            messageType: response['message']['messageType'],
                            description: response['message']['description'],
                            data: response['message']['data'],
                        };
                        this.logs[response['title']].push(obj);
                    }
                }
                break;
            case 'warning-low':
                if (index !== -1) {
                    if (this.logs[response['title']][index]['status'] === 'retry') {
                        const successIndex = this.errorsLogs.findIndex(value => value['info'] === response['message']['info']);
                        this.errorsLogs = this.errorsLogs.splice(successIndex, 1);
                    }
                    this.logs[response['title']][index]['status'] = 'warning-low';
                    this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
                    this.logs[response['title']][index]['description'] = response['message']['description'];
                    this.logs[response['title']][index]['data'] = response['message']['data'];
                } else {
                    if (response['title'] !== 'DONE') {
                        const obj = {
                            info: response['message']['info'],
                            status: 'warning-low',
                            messageType: response['message']['messageType'],
                            description: response['message']['description'],
                            data: response['message']['data'],
                        };
                        this.logs[response['title']].push(obj);
                    }
                }
                break;
            case 'initialforquery':
                if (index === -1) {
                    const obj = {
                        info: response['message']['info'],
                        status: 'initial'
                    };
                    this.logs[response['title']].push(obj);
                }
                break;
            default:
                break;
        }
    }

    executeAPI(errorPayload, apiPayload, index) {
        this._service.executeApi(apiPayload).subscribe(response => {
            if (response) {
                if (response['statuscode'] && response['statuscode'] !== 200) {
                    this.platform.openSnackBar('Please contact the Administrator', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.errorsLogs.splice(index, 1);
                    this.platform.publishEventMessage(errorPayload['executor_name'], errorPayload['version'], errorPayload['title'], {
                        info: errorPayload['info'],
                        type: 'success'
                    }, errorPayload['timeStamp'], errorPayload['action']);
                    this.platform.openSnackBar('Error resolved successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }
        }, error => {
            this.platform.openSnackBar('Please contact the Administrator', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    openTestResults(testResultsId) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/test-results/api'],  {queryParams: {resultId: testResultsId}})
        );

        window.open(url, '_blank');
    }

    toggleExecutor(ev, a) {
        $('.' + a).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-angle-right');
    }

    toggleClickExecutor(a) {
        $('.' + a).slideToggle();
    }

    getEntity() {
        if (this.apiType !== 'DATAACCESS') {
            this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, this.entityName, this.version)
                .subscribe(resp => {
                    let data: any;
                    data = resp;
                    if (data) {
                        const temp = data;
                        this.operations = [temp];
                        this.selectedCredentialTabIndex = 2;
                        this.apiActionLog.emit({deployed: true});
                    }
            });
        } else {
            this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account, this.entityName, this.version).subscribe(data => {
                if (data) {
                    this.operations = data;
                    this.selectedCredentialTabIndex = 2;
                    this.apiActionLog.emit({deployed: true});
                }
            });
        }
    }

    changeClient(value) {
        this.selected = value;
    }


    closeLogPanel() {
        this.logVisible = false;
        this.CloseClicked.emit(true);
    }

    generateExecutorAgain() {

    }


    ngAfterViewInit() {
        this.scrollContainer = this.scrollFrame.nativeElement;
        this.itemElements.changes.subscribe(_ => this.onItemElementsChanged());

    }

    onItemElementsChanged(): void {
        if (this.isNearBottom) {
            this.scrollToBottom();
        }
    }

    scrollToBottom(): void {
        this.scrollContainer.scroll({
            top: this.scrollContainer.scrollHeight,
            left: 0,
            behavior: 'smooth'
        });
    }

    isUserNearBottom(): boolean {
        const threshold = 150;
        const position = this.scrollContainer.scrollTop + this.scrollContainer.offsetHeight;
        const height = this.scrollContainer.scrollHeight;
        return position > height - threshold;
    }

    scrolled(event: any): void {
        this.isNearBottom = this.isUserNearBottom();
    }

    validateRoute() {
        // switch (this.apiType) {
        //     case 'DATAACCESS':
        //         return this.location['_platformLocation'].location.pathname === '/dataaccessapi' ? true : false;
        //     case 'BUSINESSLOGIC':
        //         return this.location['_platformLocation'].location.pathname === '/businesslogic' || this.location['_platformLocation'].location.pathname === '/businesslogic/edit' ? true : false;
        //     case 'SQLQUERY':
        //         return this.location['_platformLocation'].location.pathname === '/querybuilder' ? true : false;
        //     default:
        //         return true;
        //
        // }
        if (this.location['_platformLocation'].location.pathname === '/workflow') {
            if (this.apiType === 'WORKFLOW') {
                return true;
            }
            return false;
        }
        return true;
    }

    notifyWorkFlowBuilder() {
        this.closeLogPanel();
        this.leftPanelDataListener.assignAPIToTask.emit(true);
    }

}
